import React from 'react'
import { ModalWrapper, SelectField, StyledButton } from '../../../../../../components'
import { useDispatch, useSelector } from 'react-redux'
import { setLoader, setRefreshPage, setSectionOpen } from '../../../../../../redux/globalSlice'
import { useGlobal } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Box } from '@mui/material'
import axios from 'axios'

export const AddSection = ({ open, schoolName }) => {
  const dispatch = useDispatch()
  const sectionID = useSelector((state) => state.global.sectionId)

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const { data: sectionMap } = useGlobal({
    userUrl: `${urls.SECTION_MAP}${sectionID}`,
  })
  const sectionVal = sectionMap && sectionMap[0]

  const { data: pteacherOptions } = useGlobal({
    userUrl: `${urls.SECTION_TEACHER}${customRole == 'Admin' ? userSchoolId : schoolName}&filter=Primary`,
  })
  const { data: steacherOptions } = useGlobal({
    userUrl: `${urls.SECTION_TEACHER}${customRole == 'Admin' ? userSchoolId : schoolName}&filter=Secondary`,
  })
  const { data: staffList } = useGlobal({
    userUrl: `${urls.STAFF_LIST}${customRole == 'Admin' ? userSchoolId : schoolName}`,
  })
  const initialValues = {
    primaryTeacher: '',
    secondaryTeacher: '',
    supportStaff: '',
  }
  const validationSchema = Yup.object().shape({
    primaryTeacher: Yup.string().test(
      'primary-teacher-check',
      'Primary Teacher is required',
      function (value) {
        if (!value && sectionVal?.primary_teacher_id) {
          return true
        }
        return Yup.string().required().isValidSync(value)
      },
    ),
    // secondaryTeacher: Yup.string().test(
    //   'secondary-teacher-check',
    //   'Secondary Teacher is required',
    //   function (value) {
    //     if (!value && sectionVal?.secondary_teacher_id) {
    //       return true
    //     }
    //     return Yup.string().required().isValidSync(value)
    //   },
    // ),
  })

  const handleClose = () => {
    dispatch(setSectionOpen(false))
  }
  const handleSubmit = async () => {
    dispatch(setLoader(true))

    try {
      await validationSchema.validate(formik.values, { abortEarly: false })
      // if (
      //   (formik.values.primaryTeacher || sectionVal?.primary_teacher_id) ==
      //   (formik.values.secondaryTeacher || sectionVal?.secondary_teacher_id)
      // ) {
      //   toast.error('Primary Teacher and Secondary Teacher cannot be the same')
      //   dispatch(setLoader(false))
      //   return // Exit function if the teachers are the same
      // }
      const requestData = {
        section_map_id: sectionID,
        primary_teacher_id: formik.values.primaryTeacher || sectionVal?.primary_teacher_id,
        secondary_teacher_id: formik.values.secondaryTeacher || sectionVal?.secondary_teacher_id,
        staff_id: formik.values.supportStaff,
      }

      const response = await axios.patch(`${baseURL}${urls.ADD_SECTION}`, requestData)

      if (response.status === 200 || response.status === 201) {
        toast.success('Section updated successfully!')
        dispatch(setLoader(false))
        dispatch(setRefreshPage(true))
        handleClose()
      } else {
        toast.error(response.message)
        console.error('Error:', response)
      }
    } catch (error) {
      console.error(error)
      toast.error(error?.response?.data?.message)
      if (error instanceof Yup.ValidationError) {
        error.inner.forEach((err) => {
          toast.error(err.message)
        })
      }
      dispatch(setLoader(false))
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  })

  React.useEffect(() => {
    if (sectionMap) {
      formik.setValues({
        supportStaff: sectionVal?.support_staff,
      })
    }
  }, [sectionMap])

  const generateSelectField = (label, fieldName, optionList, val) => (
    <Box mb={0}>
      <SelectField
        label={label}
        placeholder={val ? val : 'Select'}
        options={(optionList || []).map((prod) => ({
          value: prod.employee_id,
          label: prod.employee_name,
        }))}
        required={fieldName === 'primaryTeacher'}
        width={'100%'}
        name={fieldName}
        value={formik.values[fieldName]}
        onChange={(selectedOption) => formik.setFieldValue(fieldName, selectedOption)}
      />
    </Box>
  )

  return (
    <ModalWrapper open={open} handleClose={handleClose} title={'Add Section'} width={'400px'}>
      {generateSelectField(
        'Primary Teacher',
        'primaryTeacher',
        pteacherOptions,
        sectionVal?.primary_teacher_name,
      )}
      {generateSelectField(
        'Secondary Teacher',
        'secondaryTeacher',
        steacherOptions,
        sectionVal?.secondary_teacher_name,
      )}
      {generateSelectField('Support Staff', 'supportStaff', staffList)}
      <StyledButton onClick={handleSubmit}>Submit</StyledButton>
    </ModalWrapper>
  )
}
